import React from "react";
import "../../../_shared/ProjectHeader/ProjectHeader.scss";

// ═══════════════════════════════════════════════════════════════════════════
// The Plans breadcrumb bar (ProjectHeader markup). `crumbs`: [{ title, go }];
// the last one is the current page.
// ═══════════════════════════════════════════════════════════════════════════

const OpcHeader = ({ crumbs, onBack }) => (
  <div id="project-header" className="d-flex align-items-center px-3">
    {onBack ? (
      <div
        className="d-flex align-items-center cursor-pointer"
        role="button"
        tabIndex={0}
        onClick={onBack}
        onKeyDown={(e) => e.key === "Enter" && onBack()}
      >
        <img
          src="/assets/images/back.svg"
          height={15}
          width={20}
          className="back-icon"
          alt=""
        />
        <span className="dark-grey ms-2">Back</span>
      </div>
    ) : null}
    <div className={`w-100 d-flex align-items-center ${onBack ? "ms-3" : ""}`}>
      {crumbs.map((c, i) =>
        i < crumbs.length - 1 ? (
          <div
            className="d-none d-md-flex breadcrumb breadcrub-previous"
            key={c.title}
          >
            <a
              href="#crumb"
              onClick={(e) => {
                e.preventDefault();
                c.go();
              }}
            >
              {c.title}
            </a>
            <div>
              <img
                src="/assets/images/left-icon-dark.svg"
                className="mx-2"
                alt=""
              />
            </div>
          </div>
        ) : (
          <div
            className="d-flex breadcrumb active flex-grow-1 mb-0"
            key={c.title}
          >
            <div className="d-flex align-items-center opc-crumb-main">
              <span className="mt-0 breadcrumb-title">{c.title}</span>
            </div>
          </div>
        ),
      )}
    </div>
  </div>
);

export default OpcHeader;
